const song2 = [
  [
    "Когда ты дрейфуешь в открытом океане",
    "If you're driftin' on an empty ocean",
  ],
  ["а ветер не наполняет твои паруса", "with no wind to fill your sail,"],
  ["будующее - твой горизонт", "the future, your horizon,"],
  [
    "это похоже на поиски Святого Грааля",
    "it's like searchin' for the Holy Grail.",
  ],
  ["Ты чувствуешь, что завтра не существует", "You feel there's no tomorrow"],
  ["когда всматриваешься в водную гладь ", "as you look into the water below."],
  ["там только твое отражение", "It's only your reflection"],
  ["и тебе все еще некуда идти", "and you still ain't got no place to go."],
  ["время покажет, когда - я не знаю", "Time will show, when, I don't know."],
  ["уплывай завтра", "Sail away tomorrow,"],
  ["уплывай далеко", "sailin' far away."],
  ["найти его, чтобы украсть или вымолить", "To find it steal or borrow."],
  ["однажды я буду там.", "I'll be there someday"],
  ["о женщина, я все время возвращаюсь", "Oh, woman, I keep returnin"],
  ["спеть старую песню", "to sing the same old song."],
  [
    "история рассказана, теперь я старею",
    "The story's been told, now I'm gettin' old.",
  ],
  ["скажи мне, где мое место?", "Tell me,where do I belong?"],
  ["Кажется я собираюсь сдаться", "feel like I'm goin' to surrender,"],
  ["хватит с меня испытаний", "hard times I've had enough."],
  [
    "если бы я мог найти место, чтоб спрятать лицо",
    "If I could find a place to hide my face,",
  ],
  ["я верю, я бы смог вернуться", "I believe, I could get back up."],
];

export default song2;
